module.exports = __webpack_public_path__ + "2b665b6b8faa693bce26c38cc07218aa.svg";